<template>
<div class="slider-container">
  <div class="loader" v-if="!loaded">Loading {{loadedPercent}}</div>
  <div class="slider" ref="slider" :class="{loaded}">
    <slot></slot>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import Flickity from '../flickity'

export default Vue.component('Slider', {
  data: () => ({
    loaded: false,
    loadedCount: 0,
    loadedTotal: 0,
    initialSettle: false
  }),
  mounted() {
    const flkty = new Flickity(this.$refs.slider, {
      imagesLoaded: true,
      setGallerySize: false,
      prevNextButtons: false,
      pageDots: false,
      wrapAround: true,
      cellAlign: 'center'
    })

    flkty.on('imagesLoadedProgress', function(img, slide) {
      if(this.$refs.slider) {
        this.loadedCount++
        const total = Array.from(this.$refs.slider.querySelectorAll('.slide')).length

        this.loadedTotal = total

        if(this.loadedCount === total) this.loaded = true
      }
    }.bind(this))

    flkty.on('staticClick', function(event, pointer, cellElem, cellIndex) {
      if(cellElem.classList.contains('is-selected')) {
        this.$emit('static-click', cellIndex)
      } else {
        if(cellIndex !== undefined) flkty.select(cellIndex)
      }
    }.bind(this))

    flkty.on('settle', function(event) {
      if(!this.initialSettle) return this.initialSettle = true

      if(window.matchMedia('(max-width: 560px)').matches) return null

      const otherVideos = this.$refs.slider.querySelectorAll('.slide:not(.is-selected) video')
      const selectedVideo = this.$refs.slider.querySelectorAll('.slide.is-selected video')

      Array.from(otherVideos).forEach(video => video.pause())
      Array.from(selectedVideo).forEach(video => video.play())
    }.bind(this))
  },
  computed: {
    loadedPercent() {
      if(this.loadedTotal) {
        return `${parseInt(this.loadedCount / this.loadedTotal * 100)}%`
      } else {
        return '0%'
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/_variables.scss';

.slider {
  transition: opacity 1s $ease;
  &:not(.loaded) {
    opacity: 0;
  }
  &.loaded {
    opacity: 1;
  }
  /deep/ .slide:not(.is-selected) {
    cursor: pointer;
  }
  /deep/ .slide:not(.is-selected) video {
    pointer-events: none;
  }
}
.slider-container {
  position: relative;
}
.loader {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
/deep/ * {
  outline: none;
  user-select: none;
}
</style>


// WEBPACK FOOTER //
// src/components/slider.vue